import { SIGN_UP, SIGN_UP_SUCCESS, SIGN_UP_FAILURE, ENTER_OTP, ENTER_OTP_SUCCESS, ENTER_OTP_FAILURE, RESEND_OTP, RESEND_OTP_SUCCESS, RESEND_OTP_FAILURE, SIGN_IN, SIGN_IN_SUCCESS, SIGN_OUT_USER, SIGN_IN_FAILURE, GET_USER_TYPE, GET_USER_TYPE_SUCCESS, GET_USER_TYPE_FAILURE, GET_STATE, GET_STATE_SUCCESS, GET_STATE_FAILURE, GET_LOCAL_GOVERNMENT_BY_STATE_ID, GET_LOCAL_GOVERNMENT_BY_STATE_ID_SUCCESS, GET_LOCAL_GOVERNMENT_BY_STATE_ID_FAILURE, POST_USER_TYPE, POST_USER_TYPE_SUCCESS, POST_USER_TYPE_FAILURE, POST_BUSINESS_DETAILS, POST_BUSINESS_DETAILS_SUCCESS, POST_BUSINESS_DETAILS_FAILURE, POST_BUSINESS_LOCATION, POST_BUSINESS_LOCATION_SUCCESS, POST_BUSINESS_LOCATION_FAILURE, POST_BUSINESS_HISTORY, POST_BUSINESS_HISTORY_SUCCESS, POST_BUSINESS_HISTORY_FAILURE, POST_BUSINESS_CONTACT, POST_BUSINESS_CONTACT_SUCCESS, POST_BUSINESS_CONTACT_FAILURE, POST_USER_DETAILS, POST_USER_DETAILS_SUCCESS, POST_USER_DETAILS_FAILURE, GET_RELATIONSHIP_TYPE, GET_RELATIONSHIP_TYPE_SUCCESS, GET_RELATIONSHIP_TYPE_FAILURE, FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE, NEW_PASSWORD, NEW_PASSWORD_SUCCESS, NEW_PASSWORD_FAILURE, CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE, GET_ALL_CUSTOMERS, GET_ALL_CUSTOMERS_SUCCESS, GET_ALL_CUSTOMERS_FAILURE, GET_ALL_SYSTEM_ADMIN, GET_ALL_SYSTEM_ADMIN_SUCCESS, GET_ALL_SYSTEM_ADMIN_FAILURE, GET_ALL_INDEPENDENT_DISTRIBUTORSHIP, GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_SUCCESS, GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_FAILURE, GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME, GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_SUCCESS, GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_FAILURE, GET_NATURE_OF_BUSINESS, GET_NATURE_OF_BUSINESS_SUCCESS, GET_NATURE_OF_BUSINESS_FAILURE, POST_BUSINESS_DOCUMENT, POST_BUSINESS_DOCUMENT_SUCCESS, POST_BUSINESS_DOCUMENT_FAILURE, GET_BUSINESS_DOCUMENT, GET_BUSINESS_DOCUMENT_SUCCESS, GET_BUSINESS_DOCUMENT_FAILURE, GET_USER_BY_ID, GET_USER_BY_ID_SUCCESS, GET_USER_BY_ID_FAILURE, GET_PENDING_APPLICATION, GET_PENDING_APPLICATION_SUCCESS, GET_PENDING_APPLICATION_FAILURE, GET_APPROVED_APPLICATION, GET_APPROVED_APPLICATION_SUCCESS, GET_APPROVED_APPLICATION_FAILURE, POST_ASSIGNED_DISTRIBUTOR, POST_ASSIGNED_DISTRIBUTOR_SUCCESS, POST_ASSIGNED_DISTRIBUTOR_FAILURE, GET_USER_PROFILE_DETAILS, GET_USER_PROFILE_DETAILS_SUCCESS, GET_USER_PROFILE_DETAILS_FAILURE, POST_BUSINESS_AREA, POST_BUSINESS_AREA_SUCCESS, POST_BUSINESS_AREA_FAILURE, GET_BUSINESS_AREA, GET_BUSINESS_AREA_SUCCESS, GET_BUSINESS_AREA_FAILURE, POST_PROFILE_PICTURE_AVATAR, POST_PROFILE_PICTURE_AVATAR_SUCCESS, POST_PROFILE_PICTURE_AVATAR_FAILURE, GET_ALL_ROLES, GET_ALL_ROLES_SUCCESS, GET_ALL_ROLES_FAILURE, CREATE_EMPLOYEE, CREATE_EMPLOYEE_SUCCESS, CREATE_EMPLOYEE_FAILURE, CREATE_DISTRIBUTOR_CUSTOMER, CREATE_DISTRIBUTOR_CUSTOMER_SUCCESS, CREATE_DISTRIBUTOR_CUSTOMER_FAILURE, CREATE_RETAILER_CUSTOMER, CREATE_RETAILER_CUSTOMER_SUCCESS, CREATE_RETAILER_CUSTOMER_FAILURE, CREATE_EXCLUSIVE_CUSTOMER, CREATE_EXCLUSIVE_CUSTOMER_SUCCESS, CREATE_EXCLUSIVE_CUSTOMER_FAILURE, UPDATE_EMPLOYEE_DETAILS, UPDATE_EMPLOYEE_DETAILS_SUCCESS, UPDATE_EMPLOYEE_DETAILS_FAILURE, RESTORE_EMPLOYEE_DETAILS, GET_EMPLOYEE_DATA, GET_EMPLOYEE_DATA_SUCCESS, GET_EMPLOYEE_DATA_FAILURE, RESTORE_DISTRIBUTOR_CREATION, RESTORE_RETAILER_CREATION, RESTORE_EXCLUSIVE_CREATION, UPDATE_ROLE, UPDATE_ROLE_SUCCESS, UPDATE_ROLE_FAILURE, RESTORE_ROLE_DETAILS, UPDATE_BUSINESS_DOCUMENT, UPDATE_BUSINESS_DOCUMENT_SUCCESS, UPDATE_BUSINESS_DOCUMENT_FAILURE, UPDATE_BUSINESS_AREA, UPDATE_BUSINESS_AREA_SUCCESS, UPDATE_BUSINESS_AREA_FAILURE, GET_GOOGLE_PLACES, GET_GOOGLE_PLACES_SUCCESS, GET_GOOGLE_PLACES_FAILURE, GOOGLE_SIGN_IN, GOOGLE_SIGN_IN_FAILURE, GOOGLE_SIGN_IN_SUCCESS, GOOGLE_SIGN_UP, GOOGLE_SIGN_UP_SUCCESS, GOOGLE_SIGN_UP_FAILURE, UPDATE_USER_STATUS, UPDATE_USER_STATUS_SUCCESS, UPDATE_USER_STATUS_FAILURE, RESET_USER_STATUS, UPDATE_USER_DATA, UPDATE_USER_DATA_SUCCESS, UPDATE_USER_DATA_FAILURE, UPDATE_BUSINESS_DATA, UPDATE_BUSINESS_DATA_SUCCESS, UPDATE_BUSINESS_DATA_FAILURE, DELETE_USER_ACCOUNT, DELETE_USER_ACCOUNT_SUCCESS, DELETE_USER_ACCOUNT_FAILURE, GET_REJECTED_APPLICATION, GET_REJECTED_APPLICATION_SUCCESS, GET_REJECTED_APPLICATION_FAILURE, REJECT_APPLICATION_FAILURE, REJECT_APPLICATION_SUCCESS, REJECT_APPLICATION, SEARCH_CUSTOMERS, SEARCH_CUSTOMERS_SUCCESS, SEARCH_CUSTOMERS_FAILURE, SEARCH_ROLES, SEARCH_ROLES_SUCCESS, SEARCH_ROLES_FAILURE, RESET_CUSTOMER_DETAILS, DELETE_APPLICANT_DOCUMENT, DELETE_APPLICANT_DOCUMENT_SUCCESS, DELETE_APPLICANT_DOCUMENT_FAILURE,  FETCH_TEMP_OTP_FOR_ADMIN, FETCH_TEMP_OTP_FOR_ADMIN_SUCCESS, FETCH_TEMP_OTP_FOR_ADMIN_FAILURE, RESET_TEMP_OTP_FOR_ADMIN } from "../ActionTypes";
const INIT_STATE = {
  signupdetail: false,
  signingup: false,
  signupmsg: "",
  otpcode: {},
  verifyingotp: false,
  verifiedotpmsg: "",
  resendOtpCode: {},
  verifyingResentOtp: false,
  verifyresentOtpcodeMsg: "",
  authUser: JSON.parse(localStorage.getItem("user")),
  loader: false,
  initURL: "",
  isLoading: false,
  isLoggedin: false,
  forgotPassworddetail: false,
  forgotpasswordLoading: false,
  forgotPasswordmsg: "",
  newPassworddetail: false,
  newpasswordLoading: false,
  newPasswordmsg: "",
  changePassworddetail: false,
  changePasswordLoading: false,
  changePasswordmsg: "",
  userTypeData: [],
  isloadingUserType: false,
  stateData: [],
  isloadingStateData: false,
  localGovernmentData: [],
  isloadingLocalGovernmentData: false,
  usertypePostData: {},
  usertypePostingData: false,
  usertypepostdatamsg: "",
  businessDetails: false,
  postingbusinessDetails: false,
  businessdetailsmsg: "",
  businessLocation: false,
  postingbusinessLocation: false,
  businessLocationmsg: "",
  businessHistory: false,
  postingbusinessHistory: false,
  businessHistorymsg: "",
  businessContact: false,
  postingbusinessContact: false,
  businessContactmsg: "",
  userOnboardingDetails: {},
  postinguserOnboardingDetails: false,
  userOnboardingDetailsmsg: "",
  postBusinessDocuments: {},
  postingbusinessDocument: false,
  postbusinessDocumentmsg: "",
  updateBusinessDocuments: {},
  updatingbusinessDocument: false,
  updatebusinessDocumentmsg: "",
  businessDocumentCompliance: [],
  isloadingbusinessDocumentCompliance: false,
  postBusinessAreas: {},
  postingbusinessAreas: false,
  postbusinessAreasmsg: "",
  updateBusinessAreas: {},
  updatingbusinessAreas: false,
  updatebusinessAreasmsg: "",
  businessAreasCompliance: [],
  isloadingbusinessAreasCompliance: false,
  relationshipTypeData: [],
  isloadingRelationshipType: false,
  natureOfBusinessData: [],
  isloadingNatureOfBusiness: false,
  allcustomer: [],
  isloadingAllCustomer: false,
  allSystemAdmin: [],
  isloadingAllSystemAdmin: false,
  allApplicant: [],
  isloadingAllApplicant: false,
  independentDistributorNearMe: [],
  isloadingIndependentDistributorNearMe: false,
  userById: [],
  isloadingUserById: false,
  pendingApplication: [],
  isloadingPendingApplication: false,
  approvedApplication: [],
  isloadingApprovedApplication: false,
  assignDistributor: false,
  postingAssignDistributor: false,
  assignDistributormsg: "",
  userProfileDetails: [],
  isloadingUserProfileDetails: false,
  postProfilePicAvatar: {},
  postingProfilePicAvatar: false,
  postProfilePicAvatarmsg: "",
  allRoles: [],
  isloadingAllRoles: false,
  createEmployee: {},
  postingCreateEmployee: false,
  createEmployeeDetailsmsg: "",
  createDistributor: false,
  postingCreateDistributor: false,
  createDistributorDetailsmsg: "",
  createRetailer: false,
  postingCreateRetailer: false,
  createRetailerDetailsmsg: "",
  createExclusive: false,
  postingCreateExclusive: false,
  createExclusiveDetailsmsg: "",
  employeeDetailsUpdated: false,
  isUpdatingEmployee: false,
  employeeUnpaginatedData: [],
  gettingUsersByUserType: false,
  roleUpdated: false,
  roleUpdating: false,
  loadedStateData: false,
  loadedLGAData: false,
  googlePlaces: [],
  isloadingGooglePlaces: false,
  statusUpdated: false,
  updatingStatus: false,

  userDataUpdated: false,
  updatingUserData: false,
  businessDataUpdated: false,
  updatingBusinessData: false,
  userAccountDeleted: false,
  isdeletingUserAccount: false,
  rejectedApplication:[],
  isloadingRejectedApplication: false,
  applicationRejected:false,
  isRejectingApplication: false,
  isSearched:false,
  deleteApplicantDoc: [],
  isloadingDeletedApplicantDoc: false,
  deleteApplicantDocdatamsg: "",
  tempOtpData: null,
  fetchingTempOtp: false,
  fetchedTemOtp:false,

};
function AuthReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case SIGN_UP: {
      // debugger
      return {
        ...state,
        signupdetail: false,
        signingup: true,
        signupmsg: "",
      }
    }
    case SIGN_UP_SUCCESS: {
      // debugger
      return {
        ...state,
        signupdetail: true,
        signingup: false,
        signupmsg: action.payload,
      };
    }
    case SIGN_UP_FAILURE: {
      return {
        ...state,
        signupdetail: false,
        signingup: false,
        signupmsg: action.payload,
      };
    }
    case ENTER_OTP: {
      // debugger
      return {
        ...state,
        otpcode: action.payload,
        verifyingotp: true,
        verifiedotpmsg: "",
      }
    }
    case ENTER_OTP_SUCCESS: {
      // debugger
      return {
        ...state,
        otpcode: action.payload,
        verifyingotp: false,
        verifiedotpmsg: action.payload,
      };
    }
    case ENTER_OTP_FAILURE: {
      return {
        ...state,
        otpcode: action.payload,
        verifyingotp: false,
        verifiedotpmsg: action.payload,
      };
    }
    case RESEND_OTP: {
      // debugger
      return {
        ...state,
        resendOtpCode: action.payload,
        verifyingResentOtp: true,
        verifyresentOtpcodeMsg: "",
      }
    }
    case RESEND_OTP_SUCCESS: {
      // debugger
      return {
        ...state,
        resendOtpCode: action.payload,
        verifyingResentOtp: false,
        verifyresentOtpcodeMsg: action.payload,
      };
    }
    case RESEND_OTP_FAILURE: {
      return {
        ...state,
        resendOtpCode: action.payload,
        verifyingResentOtp: false,
        verifyresentOtpcodeMsg: action.payload,
      };
    }
    case SIGN_IN: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case SIGN_IN_SUCCESS: {
      const expirationTime = new Date().getTime() + 1 * 60 * 60 * 1000; // 5 hours from now
      localStorage.setItem("user", JSON.stringify(action.payload));
      localStorage.setItem("expirationTime", expirationTime);
      return {
        ...state,
        authUser: action.payload,
        loader: true,
        initURL: "/enterotp",
        isLoggedin: true,
        isLoading: false,
      };
    }
    case SIGN_OUT_USER: {
      localStorage.removeItem("user");
      localStorage.removeItem("expirationTime");
      return {
        ...state,
        authUser: {},
      };
    }
    case SIGN_IN_FAILURE: {
      localStorage.removeItem("user");
      localStorage.removeItem("expirationTime");
      return {
        ...state,
        authUser: {},
        isLoading: false,
      };
    }
    case FORGOT_PASSWORD: {
      // debugger
      return {
        ...state,
        forgotPassworddetail: false,
        forgotpasswordLoading: true,
        forgotPasswordmsg: "",
      }
    }
    case FORGOT_PASSWORD_SUCCESS: {
      // debugger
      return {
        ...state,
        forgotPassworddetail: true,
        forgotpasswordLoading: false,
        forgotPasswordmsg: action.payload,
      };
    }
    case FORGOT_PASSWORD_FAILURE: {
      return {
        ...state,
        forgotPassworddetail: false,
        forgotpasswordLoading: false,
        forgotPasswordmsg: action.payload,
      };
    }
    case NEW_PASSWORD: {
      // debugger
      return {
        ...state,
        newPassworddetail: false,
        newpasswordLoading: true,
        newPasswordmsg: "",
      }
    }
    case NEW_PASSWORD_SUCCESS: {
      // debugger
      return {
        ...state,
        newPassworddetail: true,
        newpasswordLoading: false,
        newPasswordmsg: action.payload,
      };
    }
    case NEW_PASSWORD_FAILURE: {
      return {
        ...state,
        newPassworddetail: false,
        newpasswordLoading: false,
        newPasswordmsg: action.payload,
      };
    }
    case CHANGE_PASSWORD: {
      // debugger
      return {
        ...state,
        changePassworddetail: false,
        changePasswordLoading: true,
        changePasswordmsg: "",
      }
    }
    case CHANGE_PASSWORD_SUCCESS: {
      // debugger
      return {
        ...state,
        changePassworddetail: true,
        changePasswordLoading: false,
        changePasswordmsg: action.payload,
      };
    }
    case CHANGE_PASSWORD_FAILURE: {
      return {
        ...state,
        changePassworddetail: false,
        changePasswordLoading: false,
        changePasswordmsg: action.payload,
      };
    }
    case GET_USER_TYPE: {
      // debugger
      return {
        ...state,
        userTypeData: [],
        isloadingUserType: true
      }
    }
    case GET_USER_TYPE_SUCCESS: {
      // debugger
      return {
        ...state,
        userTypeData: action.payload,
        isloadingUserType: false
      };
    }
    case GET_USER_TYPE_FAILURE: {
      return {
        ...state,
        userTypeData: action.payload,
        isloadingUserType: false,
      };
    }
    case GET_RELATIONSHIP_TYPE: {
      // debugger
      return {
        ...state,
        relationshipTypeData: [],
        isloadingRelationshipType: true
      }
    }
    case GET_RELATIONSHIP_TYPE_SUCCESS: {
      // debugger
      return {
        ...state,
        relationshipTypeData: action?.payload,
        isloadingRelationshipType: false
      };
    }
    case GET_RELATIONSHIP_TYPE_FAILURE: {
      return {
        ...state,
        relationshipTypeData: action.payload,
        isloadingRelationshipType: false,
      };
    }
    case GET_NATURE_OF_BUSINESS: {
      // debugger
      return {
        ...state,
        natureOfBusinessData: [],
        isloadingNatureOfBusiness: true
      }
    }
    case GET_NATURE_OF_BUSINESS_SUCCESS: {
      // debugger
      return {
        ...state,
        natureOfBusinessData: action.payload,
        isloadingNatureOfBusiness: false
      };
    }
    case GET_NATURE_OF_BUSINESS_FAILURE: {
      return {
        ...state,
        natureOfBusinessData: action.payload,
        isloadingNatureOfBusiness: false,
      };
    }
    case GET_STATE: {
      // debugger
      return {
        ...state,
        stateData: [],
        isloadingStateData: true,
        loadedStateData: false,
      }
    }
    case GET_STATE_SUCCESS: {
      // debugger
      return {
        ...state,
        stateData: action.payload,
        isloadingStateData: false,
        loadedStateData: true
      };
    }
    case GET_STATE_FAILURE: {
      return {
        ...state,
        stateData: action.payload,
        isloadingStateData: false,
        loadedStateData: false,
      };
    }
    case GET_LOCAL_GOVERNMENT_BY_STATE_ID: {
      // debugger
      return {
        ...state,
        localGovernmentData: [],
        isloadingLocalGovernmentData: true,
        loadedLGAData: false
      }
    }
    case GET_LOCAL_GOVERNMENT_BY_STATE_ID_SUCCESS: {
      // debugger
      return {
        ...state,
        localGovernmentData: action.payload,
        isloadingLocalGovernmentData: false,
        loadedLGAData: true
      };
    }
    case GET_LOCAL_GOVERNMENT_BY_STATE_ID_FAILURE: {
      return {
        ...state,
        localGovernmentData: action.payload,
        isloadingLocalGovernmentData: false,
        loadedLGAData: false
      };
    }
    case POST_USER_TYPE: {
      // debugger
      return {
        ...state,
        usertypePostData: action.payload,
        usertypePostingData: true,
        usertypepostdatamsg: "",
      }
    }
    case POST_USER_TYPE_SUCCESS: {
      // debugger
      return {
        ...state,
        usertypePostData: action.payload,
        usertypePostingData: false,
        usertypepostdatamsg: "",
      };
    }
    case POST_USER_TYPE_FAILURE: {
      return {
        ...state,
        usertypePostData: action.payload,
        usertypePostingData: false,
        usertypepostdatamsg: "",
      };
    }
    case POST_BUSINESS_DETAILS: {
      // debugger
      return {
        ...state,
        businessDetails: false,
        postingbusinessDetails: true,
        businessdetailsmsg: "",
      }
    }
    case POST_BUSINESS_DETAILS_SUCCESS: {
      // debugger
      return {
        ...state,
        businessDetails: true,
        postingbusinessDetails: false,
        businessdetailsmsg: action.payload,
      };
    }
    case POST_BUSINESS_DETAILS_FAILURE: {
      return {
        ...state,
        businessDetails: false,
        postingbusinessDetails: false,
        businessdetailsmsg: action.payload,
      };
    }
    case POST_BUSINESS_LOCATION: {
      // debugger
      return {
        ...state,
        businessLocation: false,
        postingbusinessLocation: true,
        businessLocationmsg: "",
      }
    }
    case POST_BUSINESS_LOCATION_SUCCESS: {
      // debugger
      return {
        ...state,
        businessLocation: true,
        postingbusinessLocation: false,
        businessLocationmsg: action.payload,
      };
    }
    case POST_BUSINESS_LOCATION_FAILURE: {
      return {
        ...state,
        businessLocation: false,
        postingbusinessLocation: false,
        businessLocationmsg: action.payload,
      };
    }
    case POST_BUSINESS_HISTORY: {
      // debugger
      return {
        ...state,
        businessHistory: false,
        postingbusinessHistory: true,
        businessHistorymsg: "",
      }
    }
    case POST_BUSINESS_HISTORY_SUCCESS: {
      // debugger
      return {
        ...state,
        businessHistory: true,
        postingbusinessHistory: false,
        businessHistorymsg: action.payload,
      };
    }
    case POST_BUSINESS_HISTORY_FAILURE: {
      return {
        ...state,
        businessHistory: false,
        postingbusinessHistory: false,
        businessHistorymsg: action.payload,
      };
    }
    case POST_BUSINESS_CONTACT: {
      // debugger
      return {
        ...state,
        businessContact: false,
        postingbusinessContact: true,
        businessContactmsg: "",
      }
    }
    case POST_BUSINESS_CONTACT_SUCCESS: {
      // debugger
      return {
        ...state,
        businessContact: true,
        postingbusinessContact: false,
        businessContactmsg: action.payload,
      };
    }
    case POST_BUSINESS_CONTACT_FAILURE: {
      return {
        ...state,
        businessContact: false,
        postingbusinessContact: false,
        businessContactmsg: action.payload,
      };
    }
    case POST_USER_DETAILS: {
      // debugger
      return {
        ...state,
        userOnboardingDetails: action.payload,
        postinguserOnboardingDetails: true,
        userOnboardingDetailsmsg: "",
      }
    }
    case POST_USER_DETAILS_SUCCESS: {
      // debugger
      return {
        ...state,
        userOnboardingDetails: action.payload,
        postinguserOnboardingDetails: false,
        userOnboardingDetailsmsg: action.payload,
      };
    }
    case POST_USER_DETAILS_FAILURE: {
      return {
        ...state,
        userOnboardingDetails: action.payload,
        postinguserOnboardingDetails: false,
        userOnboardingDetailsmsg: action.payload,
      };
    }
    case POST_BUSINESS_DOCUMENT: {
      // debugger
      return {
        ...state,
        postBusinessDocuments: action.payload,
        postingbusinessDocument: true,
        postbusinessDocumentmsg: "",
      }
    }
    case POST_BUSINESS_DOCUMENT_SUCCESS: {
      // debugger
      return {
        ...state,
        postBusinessDocuments: action.payload,
        postingbusinessDocument: false,
        postbusinessDocumentmsg: action.payload,
      };
    }
    case POST_BUSINESS_DOCUMENT_FAILURE: {
      return {
        ...state,
        postBusinessDocuments: action.payload,
        postingbusinessDocument: false,
        postbusinessDocumentmsg: action.payload,
      };
    }
    case UPDATE_BUSINESS_DOCUMENT: {
      // debugger
      return {
        ...state,
        updateBusinessDocuments: action.body,
        updatingbusinessDocument: true,
        updatebusinessDocumentmsg: "",
      }
    }
    case UPDATE_BUSINESS_DOCUMENT_SUCCESS: {
      // debugger
      return {
        ...state,
        updateBusinessDocuments: action.body,
        updatingbusinessDocument: false,
        updatebusinessDocumentmsg: action.body,
      };
    }
    case UPDATE_BUSINESS_DOCUMENT_FAILURE: {
      return {
        ...state,
        updateBusinessDocuments: action.body,
        updatingbusinessDocument: false,
        updatebusinessDocumentmsg: action.body,
      };
    }
    case GET_BUSINESS_DOCUMENT: {
      // debugger
      return {
        ...state,
        businessDocumentCompliance: [],
        isloadingbusinessDocumentCompliance: true
      }
    }
    case GET_BUSINESS_DOCUMENT_SUCCESS: {
      // debugger
      return {
        ...state,
        businessDocumentCompliance: action.payload,
        isloadingbusinessDocumentCompliance: false
      };
    }
    case GET_BUSINESS_DOCUMENT_FAILURE: {
      return {
        ...state,
        businessDocumentCompliance: action.payload,
        isloadingbusinessDocumentCompliance: false,
      };
    }
    case POST_BUSINESS_AREA: {
      // debugger
      return {
        ...state,
        postBusinessAreas: action.payload,
        postingbusinessAreas: true,
        postbusinessAreasmsg: "",
      }
    }
    case POST_BUSINESS_AREA_SUCCESS: {
      // debugger
      return {
        ...state,
        postBusinessAreas: action.payload,
        postingbusinessAreas: false,
        postbusinessAreasmsg: action.payload,
      };
    }
    case POST_BUSINESS_AREA_FAILURE: {
      return {
        ...state,
        postBusinessAreas: action.payload,
        postingbusinessAreas: false,
        postbusinessAreasmsg: action.payload,
      };
    }
    case UPDATE_BUSINESS_AREA: {
      // debugger
      return {
        ...state,
        updateBusinessAreas: action.payload,
        updatingbusinessAreas: true,
        updatebusinessAreasmsg: "",
      }
    }
    case UPDATE_BUSINESS_AREA_SUCCESS: {
      // debugger
      return {
        ...state,
        updateBusinessAreas: action.payload,
        updatingbusinessAreas: false,
        updatebusinessAreasmsg: action.payload,
      };
    }
    case UPDATE_BUSINESS_AREA_FAILURE: {
      return {
        ...state,
        updateBusinessAreas: action.payload,
        updatingbusinessAreas: false,
        updatebusinessAreasmsg: action.payload,
      };
    }
    case GET_BUSINESS_AREA: {
      // debugger
      return {
        ...state,
        businessAreasCompliance: [],
        isloadingbusinessAreasCompliance: true
      }
    }
    case GET_BUSINESS_AREA_SUCCESS: {
      // debugger
      return {
        ...state,
        businessAreasCompliance: action.payload,
        isloadingbusinessAreasCompliance: false
      };
    }
    case GET_BUSINESS_AREA_FAILURE: {
      return {
        ...state,
        businessAreasCompliance: action.payload,
        isloadingbusinessAreasCompliance: false,
      };
    }
    case GET_ALL_CUSTOMERS: {
      // debugger
      return {
        ...state,
        allcustomer: [],
        isloadingAllCustomer: true
      }
    }
    case GET_ALL_CUSTOMERS_SUCCESS: {
      // debugger
      return {
        ...state,
        allcustomer: action.payload,
        isloadingAllCustomer: false
      };
    }
    case GET_ALL_CUSTOMERS_FAILURE: {
      return {
        ...state,
        allcustomer: action.payload,
        isloadingAllCustomer: false,
      };
    }
    case GET_ALL_SYSTEM_ADMIN: {
      // debugger
      return {
        ...state,
        allSystemAdmin: [],
        isloadingAllSystemAdmin: true
      }
    }
    case GET_ALL_SYSTEM_ADMIN_SUCCESS: {
      // debugger
      return {
        ...state,
        allSystemAdmin: action.payload,
        isloadingAllSystemAdmin: false
      };
    }
    case GET_ALL_SYSTEM_ADMIN_FAILURE: {
      return {
        ...state,
        allSystemAdmin: action.payload,
        isloadingAllSystemAdmin: false,
      };
    }
    case GET_ALL_INDEPENDENT_DISTRIBUTORSHIP: {
      // debugger
      return {
        ...state,
        allApplicant: [],
        isloadingAllApplicant: true,
        isSearched:false
      }
    }
    case GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_SUCCESS: {
      // debugger
      return {
        ...state,
        allApplicant: action.payload,
        isloadingAllApplicant: false,
        isSearched:false
      };
    }
    case GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_FAILURE: {
      return {
        ...state,
        allApplicant: action.payload,
        isloadingAllApplicant: false,
        isSearched:false
      };
    }
    case GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME: {
      // debugger
      return {
        ...state,
        independentDistributorNearMe: [],
        isloadingIndependentDistributorNearMe: true
      }
    }
    case GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_SUCCESS: {
      // debugger
      return {
        ...state,
        independentDistributorNearMe: action.payload,
        isloadingIndependentDistributorNearMe: false
      };
    }
    case GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_FAILURE: {
      return {
        ...state,
        independentDistributorNearMe: action.payload,
        isloadingIndependentDistributorNearMe: false,
      };
    }
    case GET_USER_BY_ID: {
      // debugger
      return {
        ...state,
        userById: [],
        isloadingUserById: true
      }
    }
    case GET_USER_BY_ID_SUCCESS: {
      // debugger
      return {
        ...state,
        userById: action.body,
        isloadingUserById: false
      };
    }
    case GET_USER_BY_ID_FAILURE: {
      return {
        ...state,
        userById: action.body,
        isloadingUserById: false,
      };
    }
    case GET_PENDING_APPLICATION: {
      // debugger
      return {
        ...state,
        pendingApplication: [],
        isloadingPendingApplication: true
      }
    }
    case GET_PENDING_APPLICATION_SUCCESS: {
      // debugger
      return {
        ...state,
        pendingApplication: action.payload,
        isloadingPendingApplication: false
      };
    }
    case GET_PENDING_APPLICATION_FAILURE: {
      return {
        ...state,
        pendingApplication: action.payload,
        isloadingPendingApplication: false,
      };
    }
    case GET_APPROVED_APPLICATION: {
      // debugger
      return {
        ...state,
        approvedApplication: [],
        isloadingApprovedApplication: true
      }
    }
    case GET_APPROVED_APPLICATION_SUCCESS: {
      // debugger
      return {
        ...state,
        approvedApplication: action.payload,
        isloadingApprovedApplication: false
      };
    }
    case GET_APPROVED_APPLICATION_FAILURE: {
      return {
        ...state,
        approvedApplication: action.payload,
        isloadingApprovedApplication: false,
      };
    }
    case POST_ASSIGNED_DISTRIBUTOR: {
      // debugger
      return {
        ...state,
        assignDistributor: false,
        postingAssignDistributor: true,
        assignDistributormsg: "",
      }
    }
    case POST_ASSIGNED_DISTRIBUTOR_SUCCESS: {
      // debugger
      return {
        ...state,
        assignDistributor: true,
        postingAssignDistributor: false,
        assignDistributormsg: action.payload,
      };
    }
    case POST_ASSIGNED_DISTRIBUTOR_FAILURE: {
      return {
        ...state,
        assignDistributor: false,
        postingAssignDistributor: false,
        assignDistributormsg: action.payload,
      };
    }
    case GET_USER_PROFILE_DETAILS: {
      // debugger
      return {
        ...state,
        userProfileDetails: [],
        isloadingUserProfileDetails: true
      }
    }
    case GET_USER_PROFILE_DETAILS_SUCCESS: {
      // debugger
      return {
        ...state,
        userProfileDetails: action.payload,
        isloadingUserProfileDetails: false
      };
    }
    case GET_USER_PROFILE_DETAILS_FAILURE: {
      return {
        ...state,
        userProfileDetails: action.payload,
        isloadingUserProfileDetails: false,
      };
    }
    case POST_PROFILE_PICTURE_AVATAR: {
      // debugger
      return {
        ...state,
        postProfilePicAvatar: action.payload,
        postingProfilePicAvatar: true,
        postProfilePicAvatarmsg: "",
      }
    }
    case POST_PROFILE_PICTURE_AVATAR_SUCCESS: {
      // debugger
      return {
        ...state,
        postProfilePicAvatar: action.payload,
        postingProfilePicAvatar: false,
        postProfilePicAvatarmsg: action.payload,
      };
    }
    case POST_PROFILE_PICTURE_AVATAR_FAILURE: {
      return {
        ...state,
        postProfilePicAvatar: action.payload,
        postingProfilePicAvatar: false,
        postProfilePicAvatarmsg: action.payload,
      };
    }
    case GET_ALL_ROLES: {
      // debugger
      return {
        ...state,
        allRoles: [],
        isloadingAllRoles: true
      }
    }
    case GET_ALL_ROLES_SUCCESS: {
      // debugger
      return {
        ...state,
        allRoles: action.payload,
        isloadingAllRoles: false
      };
    }
    case GET_ALL_ROLES_FAILURE: {
      return {
        ...state,
        allRoles: action.payload,
        isloadingAllRoles: false,
      };
    }
    case CREATE_EMPLOYEE: {
      // debugger
      return {
        ...state,
        createEmployee: action.payload,
        postingCreateEmployee: true,
        createEmployeeDetailsmsg: "",
      }
    }
    case CREATE_EMPLOYEE_SUCCESS: {
      // debugger
      return {
        ...state,
        createEmployee: action.payload,
        postingCreateEmployee: false,
        createEmployeeDetailsmsg: action.payload,
      };
    }
    case CREATE_EMPLOYEE_FAILURE: {
      return {
        ...state,
        createEmployee: action.payload,
        postingCreateEmployee: false,
        createEmployeeDetailsmsg: action.payload,
      };
    }
    case CREATE_DISTRIBUTOR_CUSTOMER: {
      // debugger
      return {
        ...state,
        createDistributor: false,
        postingCreateDistributor: true,
        createDistributorDetailsmsg: "",
      }
    }
    case CREATE_DISTRIBUTOR_CUSTOMER_SUCCESS: {
      // debugger
      return {
        ...state,
        createDistributor: true,
        postingCreateDistributor: false,
        createDistributorDetailsmsg: action.payload,
      };
    }
    case CREATE_DISTRIBUTOR_CUSTOMER_FAILURE: {
      return {
        ...state,
        createDistributor: false,
        postingCreateDistributor: false,
        createDistributorDetailsmsg: action.payload,
      };
    }
    case RESTORE_DISTRIBUTOR_CREATION: {
      return {
        ...state,
        createDistributor: false,
        postingCreateDistributor: false,
        createDistributorDetailsmsg: "",
      };
    }
    case CREATE_RETAILER_CUSTOMER: {
      // debugger
      return {
        ...state,
        createRetailer: false,
        postingCreateRetailer: true,
        createRetailerDetailsmsg: "",
      }
    }
    case CREATE_RETAILER_CUSTOMER_SUCCESS: {
      // debugger
      return {
        ...state,
        createRetailer: true,
        postingCreateRetailer: false,
        createRetailerDetailsmsg: action.payload,
      };
    }
    case CREATE_RETAILER_CUSTOMER_FAILURE: {
      return {
        ...state,
        createRetailer: false,
        postingCreateRetailer: false,
        createRetailerDetailsmsg: action.payload,
      };
    }
    case RESTORE_RETAILER_CREATION: {
      return {
        ...state,
        createRetailer: false,
        postingCreateRetailer: false,
        createRetailerDetailsmsg: "",
      };
    }
    case CREATE_EXCLUSIVE_CUSTOMER: {
      // debugger
      return {
        ...state,
        createExclusive: false,
        postingCreateExclusive: true,
        createExclusiveDetailsmsg: "",
      }
    }
    case CREATE_EXCLUSIVE_CUSTOMER_SUCCESS: {
      // debugger
      return {
        ...state,
        createExclusive: true,
        postingCreateExclusive: false,
        createExclusiveDetailsmsg: action.payload,
      };
    }
    case CREATE_EXCLUSIVE_CUSTOMER_FAILURE: {
      return {
        ...state,
        createExclusive: false,
        postingCreateExclusive: false,
        createExclusiveDetailsmsg: action.payload,
      };
    }
    case RESTORE_EXCLUSIVE_CREATION: {
      return {
        ...state,
        createExclusive: false,
        postingCreateExclusive: false,
        createExclusiveDetailsmsg: "",
      };
    }
    case UPDATE_EMPLOYEE_DETAILS: {
      // debugger
      return {
        ...state,
        employeeDetailsUpdated: false,
        isUpdatingEmployee: true,

      }
    }
    case UPDATE_EMPLOYEE_DETAILS_SUCCESS: {
      // debugger
      return {
        ...state,
        employeeDetailsUpdated: true,
        isUpdatingEmployee: false,
      };
    }
    case UPDATE_EMPLOYEE_DETAILS_FAILURE: {
      return {
        ...state,
        employeeDetailsUpdated: false,
        isUpdatingEmployee: false,
      };
    }
    case RESTORE_EMPLOYEE_DETAILS: {
      return {
        ...state,
        employeeDetailsUpdated: false,
        isUpdatingEmployee: false,
      };
    }
    case GET_EMPLOYEE_DATA: {
      return {
        ...state,
        employeeUnpaginatedData: [],
        gettingEmployeeUnpaginatedData: true,
      }
    }
    case GET_EMPLOYEE_DATA_SUCCESS: {
      return {
        ...state,
        employeeUnpaginatedData: action.payload,
        gettingEmployeeUnpaginatedData: false,
      };
    }
    case GET_EMPLOYEE_DATA_FAILURE: {
      return {
        ...state,
        employeeUnpaginatedData: [],
        gettingEmployeeUnpaginatedData: false,
      };
    }
    case UPDATE_ROLE: {
      return {
        ...state,
        roleUpdated: false,
        roleUpdating: true
      }
    }
    case UPDATE_ROLE_SUCCESS: {
      return {
        ...state,
        roleUpdated: true,
        roleUpdating: false
      };
    }
    case UPDATE_ROLE_FAILURE: {
      return {
        ...state,
        roleUpdated: false,
        roleUpdating: false
      };
    }
    case RESTORE_ROLE_DETAILS: {
      return {
        ...state,
        roleUpdated: false,
        roleUpdating: false
      };
    }
    case GET_GOOGLE_PLACES: {
      // debugger
      return {
        ...state,
        googlePlaces: [],
        isloadingGooglePlaces: true
      }
    }
    case GET_GOOGLE_PLACES_SUCCESS: {
      // debugger
      return {
        ...state,
        googlePlaces: action.payload,
        isloadingGooglePlaces: false
      };
    }
    case GET_GOOGLE_PLACES_FAILURE: {
      return {
        ...state,
        googlePlaces: action.payload,
        isloadingGooglePlaces: false,
      };
    }
    case GOOGLE_SIGN_IN: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case GOOGLE_SIGN_IN_SUCCESS: {
      const expirationTime = new Date().getTime() + 1 * 60 * 60 * 1000; // 5 hours from now
      localStorage.setItem("user", JSON.stringify(action.payload));
      localStorage.setItem("expirationTime", expirationTime);
      return {
        ...state,
        authUser: action.payload,
        loader: true,
        initURL: "/enterotp",
        isLoggedin: true,
        isLoading: false,
      };
    }
    case GOOGLE_SIGN_IN_FAILURE: {
      return {
        ...state,
        isLoading: false,
      }
    }
    case GOOGLE_SIGN_UP: {
      // debugger
      return {
        ...state,
        signupdetail: false,
        signingup: true,
        signupmsg: "",
      }
    }
    case GOOGLE_SIGN_UP_SUCCESS: {
      // debugger
      localStorage.setItem("usersignupemail", JSON.stringify(action.payload?.user?.email));
      return {
        ...state,
        signupdetail: true,
        signingup: false,
        signupmsg: action.payload?.message,

      };
    }
    case GOOGLE_SIGN_UP_FAILURE: {
      return {
        ...state,
        signupdetail: false,
        signingup: false,
        signupmsg: action.payload?.message,
      };
    }
    case UPDATE_USER_STATUS: {
      return {
        ...state,
        statusUpdated: false,
        updatingStatus: true
      }
    }
    case UPDATE_USER_STATUS_SUCCESS: {
      debugger
      return {
        ...state,
        statusUpdated: true,
        updatingStatus: false

      };
    }
    case UPDATE_USER_STATUS_FAILURE: {
      return {
        ...state,
        statusUpdated: false,
        updatingStatus: false
      };
    }
    case RESET_USER_STATUS: {
      return {
        ...state,
        statusUpdated: false,
        updatingStatus: false
      };
    }
    case UPDATE_USER_DATA: {
      return {
        ...state,
        userDataUpdated: false,
        updatingUserData: true,
      }
    }
    case UPDATE_USER_DATA_SUCCESS: {
      debugger
      return {
        ...state,
        userDataUpdated: true,
        updatingUserData: false,
      };
    }
    case UPDATE_USER_DATA_FAILURE: {
      return {
        ...state,
        userDataUpdated: false,
        updatingUserData: false,
      };
    }
    case UPDATE_BUSINESS_DATA: {
      return {
        ...state,

        businessDataUpdated: false,
        updatingBusinessData: true
      }
    }
    case UPDATE_BUSINESS_DATA_SUCCESS: {
      debugger
      return {
        ...state,
        businessDataUpdated: true,
        updatingBusinessData: false

      };
    }
    case UPDATE_BUSINESS_DATA_FAILURE: {
      return {
        ...state,
        businessDataUpdated: false,
        updatingBusinessData: false
      };
    }
    case DELETE_USER_ACCOUNT: {
      return {
        ...state,

        userAccountDeleted: false,
        isdeletingUserAccount: true
      }
    }
    case DELETE_USER_ACCOUNT_SUCCESS: {
      debugger
      return {
        ...state,
        userAccountDeleted: true,
        isdeletingUserAccount: false

      };
    }
    case DELETE_USER_ACCOUNT_FAILURE: {
      return {
        ...state,
        userAccountDeleted: false,
        isdeletingUserAccount: false
      };
    }
    case GET_REJECTED_APPLICATION: {
      // debugger
      return {
        ...state,
        rejectedApplication: [],
        isloadingRejectedApplication: true
      }
    }
    case GET_REJECTED_APPLICATION_SUCCESS: {
      // debugger
      return {
        ...state,
        rejectedApplication: action.payload,
        isloadingRejectedApplication: false
      };
    }
    case GET_REJECTED_APPLICATION_FAILURE: {
      return {
        ...state,
        rejectedApplication:[],
        isloadingRejectedApplication: false,
      };
    }
    case REJECT_APPLICATION: {
      // debugger
      return {
        ...state,
        applicationRejected:false,
        isRejectingApplication: true,
      }
    }
    case REJECT_APPLICATION_SUCCESS: {
      // debugger
      return {
        ...state,
        applicationRejected:true,
        isRejectingApplication: false,
      };
    }
    case REJECT_APPLICATION_FAILURE: {
      return {
        ...state,
        applicationRejected:false,
        isRejectingApplication: false,
      };
    }
    case SEARCH_CUSTOMERS: {
      // debugger
      return {
        ...state,
        allApplicant: [],
        isloadingAllApplicant: true,
        isSearched:false
      }
    }
    case SEARCH_CUSTOMERS_SUCCESS: {
      // debugger
      return {
        ...state,
        allApplicant: action.payload,
        isloadingAllApplicant: false,
        isSearched:true
      };
    }
    case SEARCH_CUSTOMERS_FAILURE: {
      return {
        ...state,
        allApplicant: action.payload,
        isloadingAllApplicant: false,
        isSearched:false
      };
    }
    case SEARCH_ROLES: {
      // debugger
      return {
        ...state,
        allRoles: [],
        isloadingAllRoles: true
      }
    }
    case SEARCH_ROLES_SUCCESS: {
      // debugger
      return {
        ...state,
        allRoles: action.payload,
        isloadingAllRoles: false
      };
    }
    case SEARCH_ROLES_FAILURE: {
      return {
        ...state,
        allRoles: action.payload,
        isloadingAllRoles: false,
      };
    }
    case RESET_CUSTOMER_DETAILS: {
      return {
        ...state,
        allApplicant: [],
        isloadingAllApplicant: false,
      };
    }
    case DELETE_APPLICANT_DOCUMENT: {
      // debugger
      return {
          ...state,
          deleteApplicantDoc: action.payload,
          isloadingDeletedApplicantDoc: true,
          deleteApplicantDocdatamsg: "",
      }
  }
  case DELETE_APPLICANT_DOCUMENT_SUCCESS: {
      // debugger
      return {
          ...state,
          deleteApplicantDoc: action.payload,
          isloadingDeletedApplicantDoc: false,
          deleteApplicantDocdatamsg: "",
      };
  }
  case DELETE_APPLICANT_DOCUMENT_FAILURE: {
      return {
          ...state,
          deleteApplicantDoc: action.payload,
          isloadingDeletedApplicantDoc: false,
          deleteApplicantDocdatamsg: "",
      };
  }
  case FETCH_TEMP_OTP_FOR_ADMIN: {
      return {
          ...state,
          tempOtpData: null,
          fetchingTempOtp: true,
          fetchedTemOtp: false,

      };
  }
  case FETCH_TEMP_OTP_FOR_ADMIN_SUCCESS: {
      return {
          ...state,
          tempOtpData: action.payload,
          fetchingTempOtp: false,
          fetchedTemOtp: true,

      };
  }
  case FETCH_TEMP_OTP_FOR_ADMIN_FAILURE: {
      return {
          ...state,
          tempOtpData: null,
          fetchingTempOtp: false,
          fetchedTemOtp:false,

      };
  }
  case RESET_TEMP_OTP_FOR_ADMIN: {
      return {
          ...state,
          tempOtpData: null,
          fetchingTempOtp: false,
          fetchedTemOtp:false,

      };
  }
    default:
      return state;
  }
}
export default AuthReducer;

export const getAuthReducer = state => state.authReducer
